import { useEffect, useState } from 'react';
import axios from 'axios';
import { Button, Col, FloatingLabel, Row, Form, Table } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import moment from 'moment';

const RescuedDistribution = () => {
  const navigate = useNavigate();

  const [identifiers, setIdentifiers] = useState([]);
  const [families, setFamilies] = useState([]);
  const [verifiers, setVerifiers] = useState([]);
  const [selectedVerifier, setSelectedVerifier] = useState("");
  const [distributionDate, setDistributionDate] = useState(moment().format("YYYY-MM-DD"));
  const [selectedFamilyIds, setSelectedFamilyIds] = useState([]); // NEW
  const [search, setSearch] = useState("");

  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/rescued-initial-data`)
      .then((res) => {
        setIdentifiers(res.data.organizations);
      })
      .catch(console.error);
  }, []);

  const handleChangeIdentifier = (e) => {
    const id = e.target.value;
    if (!id) return;

    axios.get(`${process.env.REACT_APP_API_URL}/selected-identifier-for-business/${id}`)
      .then((res) => {
        setFamilies(res.data.people);
        setVerifiers(res.data.verifiers);
        setSelectedVerifier("");
        setSelectedFamilyIds([]);
        setSearch("");
      })
      .catch(console.error);
  };

  // Checkbox logic
  const toggleFamily = (id) => {
    setSelectedFamilyIds((prev) =>
      prev.includes(id) ? prev.filter((fid) => fid !== id) : [...prev, id]
    );
  };

  const toggleSelectAll = () => {
    const filteredIds = filteredFamilies.map(f => f.id);
    if (filteredIds.every(id => selectedFamilyIds.includes(id))) {
      setSelectedFamilyIds(selectedFamilyIds.filter(id => !filteredIds.includes(id)));
    } else {
      setSelectedFamilyIds([...new Set([...selectedFamilyIds, ...filteredIds])]);
    }
  };

  const searchTerm = search.trim().toLowerCase();
  const filteredFamilies = families.filter(fam =>
    !searchTerm ||
    fam.f_number?.toString().toLowerCase().includes(searchTerm) ||
    fam.beneficiary_name?.toLowerCase().includes(searchTerm) ||
    fam.mob?.toString().toLowerCase().includes(searchTerm) ||
    fam.city?.name?.toLowerCase().includes(searchTerm)
  );

  const handleSubmit = () => {
    if (!selectedVerifier) {
      Swal.fire("Warning", "Please select a verifier", "warning");
      return;
    }
    if (selectedFamilyIds.length === 0) {
      Swal.fire("Warning", "Please select at least one family", "warning");
      return;
    }
    if (!distributionDate) {
      Swal.fire("Warning", "Please select distribution date", "warning");
      return;
    }

    axios.post(`${process.env.REACT_APP_API_URL}/distribute-business`, {
      verifier_id: selectedVerifier,
      family_ids: selectedFamilyIds,

      distribution_date: distributionDate,
    })
      .then(() => {
        Swal.fire("Success", "Selected families distributed", "success");
        navigate('/distribution-dashboard');
      })
      .catch((error) => {
        Swal.fire("Error", "Failed to distribute families", "error");
        console.error(error);
      });
  };

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">Distribute For Business</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item"><Link to="#" style={{color:"#077834"}}>home</Link></li>
                <li className="mc-breadcrumb-item"><Link to="#" style={{color:"#077834"}}>Finances</Link></li>
                <li className="mc-breadcrumb-item">Data Distribution</li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <FloatingLabel label="Select Organization" className="mb-3">
            <Form.Select onChange={handleChangeIdentifier}>
              <option value="">Select...</option>
              {identifiers.map(identifier => (
                <option key={identifier.id} value={identifier.id}>{identifier.name}</option>
              ))}
            </Form.Select>
          </FloatingLabel>
        </Col>

        <Col md={3}>
          <FloatingLabel label="Total families" className="mb-3">
            <Form.Control value={families.length} disabled />
          </FloatingLabel>
        </Col>

        <Col md={3}>
          <FloatingLabel label="Selected families" className="mb-3">
            <Form.Control value={selectedFamilyIds.length} disabled />
          </FloatingLabel>
        </Col>
      </Row>

      {families.length > 0 && (
        <>
          <Row className="mb-3">
            <Col md={4}>
              <FloatingLabel label="Search FSF-ID / Name / Contact / City">
                <Form.Control
                  type="text"
                  placeholder="Search FSF-ID / Name / Contact / City"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </FloatingLabel>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <h5>Families List</h5>
              <Table striped bordered hover size="sm" responsive>
                <thead>
                  <tr>
                    <th style={{ width: "40px" }}>
                      <Form.Check
                        type="checkbox"
                        checked={filteredFamilies.length > 0 && filteredFamilies.every(f => selectedFamilyIds.includes(f.id))}
                        onChange={toggleSelectAll}
                      />
                    </th>
                    <th>#</th>
                    <th>Family Name</th>
                    <th>Contact</th>
                    <th>City</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredFamilies.map(fam => (
                    <tr key={fam.id}>
                      <td>
                        <Form.Check
                          type="checkbox"
                          checked={selectedFamilyIds.includes(fam.id)}
                          onChange={() => toggleFamily(fam.id)}
                        />
                      </td>
                      <td>{fam.f_number}</td>
                      <td>{fam.beneficiary_name || 'N/A'}</td>
                      <td>{fam.mob || '-'}</td>
                      <td>{fam.city?.name || '-'}</td>
                    </tr>
                  ))}
                  {filteredFamilies.length === 0 && (
                    <tr><td colSpan={5} className="text-center">No families match your search.</td></tr>
                  )}
                </tbody>
              </Table>
            </Col>
          </Row>

          <Row>
            <Col md={8}>
              <FloatingLabel label="Select Verifier" className="mb-3">
                <Form.Select value={selectedVerifier} onChange={(e) => setSelectedVerifier(e.target.value)}>
                  <option value="">Select verifier to assign selected families</option>
                  {verifiers.map(verifier => (
                    <option key={verifier.id} value={verifier.id}>{verifier.name}</option>
                  ))}
                </Form.Select>
              </FloatingLabel>
            </Col>
            <Col md={4}>
              <FloatingLabel label="Distribution Date" className="mb-3">
                <Form.Control type="date" value={distributionDate} onChange={e => setDistributionDate(e.target.value)} />
              </FloatingLabel>
            </Col>
          </Row>
        </>
      )}

      <Button className="mt-3" style={{backgroundColor:"#077834"}} onClick={handleSubmit}>Submit</Button>
    </PageLayout>
  );
};

export default RescuedDistribution;
